export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=705bfddf9ad6c61d01fb19735455c169226106bf81&name=pushAdClickData!'